import React from 'react';

import { useIntl } from 'react-intl';

import { FavoriteIcon } from 'components/favorite-icon';
import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';
import { useFavoriteStore } from 'hooks/favorite-stores';

import { StoreIconWrap, UnstyledButtonNoSpacing } from './styled';

const Animation: LazyComponent<{}> = lazyWithNullFallback(() =>
  import('../lottie/favorite/loading')
);

export const FavoriteStoreIcon: React.FC<{ storeId: string; storeNumber: string }> = ({
  storeId,
  storeNumber,
}) => {
  const {
    favStoresEnabled,
    toggleFavorite,
    isFavorite,
    ErrorFavoriteStoreDialog,
    favStoreLoading,
  } = useFavoriteStore(storeId, storeNumber);

  const { formatMessage } = useIntl();

  if (!favStoresEnabled) {
    return null;
  }

  // Use the current state of the Fav Icon as fallback when we're lazy loading the lottie animation
  const FavIcon = (
    <UnstyledButtonNoSpacing
      data-testid="fav-icon"
      onClick={toggleFavorite}
      aria-label={formatMessage({
        id: isFavorite ? 'removeRestaurantFromFavorites' : 'setRestaurantAsFavorite',
      })}
    >
      <FavoriteIcon isFavorite={isFavorite} />
    </UnstyledButtonNoSpacing>
  );

  return (
    <>
      <StoreIconWrap>
        {favStoreLoading ? (
          <React.Suspense data-testid="fav_store_loading_animation" fallback={FavIcon}>
            <Animation />
          </React.Suspense>
        ) : (
          FavIcon
        )}
      </StoreIconWrap>
      <ErrorFavoriteStoreDialog />
    </>
  );
};
